module.exports = __webpack_public_path__ + "static/media/traffic-alert-alert.03e0adb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/traffic-alert-alert.svg
// module id = 658
// module chunks = 0